
import Vue from "vue"

const state = {
  version: []
}

const getters = {
  version: state => state.version,
}

const actions = {
  load_version ({commit}, payload) {
    var strUrl = '' // (payload) ? '?company='+payload : ''
    if (payload) {
      strUrl = '?company=all'// (payload) ? '?company='+payload : ''
    }
    Vue.axios
      .get('pricelist/version' + strUrl)
      .then(r => r.data)
      .then(version => {
        commit('SET_VERSION', version)
      })
  },

}

const mutations = {

  SET_VERSION (state, version) {
    state.version = version
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/version.js